import { createContext } from 'react';

const GlobalContainerContext = createContext();

export default GlobalContainerContext;
